import {
  createDomMotionComponent,
  AnimatePresence,
  useAnimation,
  useMotionValue,
  useDeprecatedInvertedScale as useInvertedScale
} from "framer-motion";

const motion = {
  div: createDomMotionComponent("div"),
  span: createDomMotionComponent("span"),
  path: createDomMotionComponent("path"),
  svg: createDomMotionComponent("svg")
};

export {
  motion,
  AnimatePresence,
  useAnimation,
  useMotionValue,
  useInvertedScale
};
